// light
import { fontsConfiguration as fontsLight } from "./light/fonts";
import { buttonsConfiguration as buttonsLight } from "./light/buttons";
import { inputConfiguration as inputLight } from "./light/inputs";
import { cardsConfiguration as cardsLight } from "./light/cards";
import { sidebarConfiguration as sidebarLight } from "./light/sidebar";
import { dropdownConfiguration as dropdownLight } from "./light/dropdown";
import { tableConfiguration as tableLight } from "./light/table";
import {
  colors as colorsLight,
  hoverColors as hoverColorsLight,
  borderColors as borderColorsLight,
} from "./light/colors";

// common
import { radiusConfig, fontWeightConfig } from "./common";

const defaultFontFamily = '"Mona Sans", sans-serif';
const fontFamilyArabic = '"Noto Sans Arabic", sans-serif';
// const defaultFontFamily = '"Manrope", sans-serif';

export const lightTheme = {
  defaultFontFamily,
  fontFamilyArabic,
  font: fontsLight,
  button: buttonsLight,
  card: cardsLight,
  input: inputLight,
  colors: {
    main: colorsLight,
    hover: hoverColorsLight,
    border: borderColorsLight,
  },
  fontWeights: fontWeightConfig,
  borderRadii: radiusConfig,

  sidebar: sidebarLight,
  dropdown: dropdownLight,
  table: tableLight,
};

export const darkTheme = {
  font: {},
  button: {},
};
